module.exports = __webpack_public_path__ + "static/media/laptopGuy.8068fcb8.svg";